// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_os-0";
export var buttonContainer = "_os-3";
export var cancelButton = "_os-4";
export var headerSection = "_os-6";
export var headerTitle = "_os-9";
export var messageSideLeft = "_os-1";
export var messageSideRight = "_os-2";
export var orderNumberContainer = "_os-7";
export var orderNumberLabel = "_os-8";
export var submitButton = "_os-5";